import React, {memo} from "react"
import {useTranslation} from "react-i18next";

import Grid from "@mui/material/Grid";
import MDInput from "materialDashboard/components/MDInput";
import FormSection from "../../../components/FormSection";
import {formikPropertyChanged} from "./index";


const Notes = memo(({formik, inputDisabled}) => {
    const {t} = useTranslation(['models23']);

    return <FormSection title={t('model23Form.notesTitle')}>
        <Grid container rowSpacing={3} columnSpacing={4}>
            <Grid item xs={12}>
                <MDInput name="notes"
                         label={t('model23Form.notes')}
                         value={formik.values.notes ?? ""}
                         onChange={formik.handleChange}
                         error={formik.touched?.notes && Boolean(formik.errors.notes)}
                         helperText={formik.touched.notes && formik.errors.notes}
                         variant="standard"
                         multiline
                         rows={5}
                         fullWidth
                         disabled={inputDisabled}
                />
            </Grid>
            <Grid item xs={12}>
                <MDInput name="feedback"
                         label={t('model23Form.feedback')}
                         value={formik.values.feedback ?? ""}
                         onChange={formik.handleChange}
                         error={formik.touched.feedback?.feedback && Boolean(formik.errors.feedback)}
                         helperText={formik.touched.feedback && formik.errors.feedback}
                         variant="standard"
                         multiline
                         rows={5}
                         fullWidth
                         disabled={inputDisabled}
                />
            </Grid>
        </Grid>
    </FormSection>
}, (prevProps, nextProps) => formikPropertyChanged(prevProps, nextProps, 'notes') && formikPropertyChanged(prevProps, nextProps, 'feedback'));


export default Notes;